export default {
  // 對話框標題
  saveCanvas: "保存畫布",
  addNewCaseAndSaveCanvas: "添加新案件並保存畫布",

  // 表單標籤
  canvasName: "畫布名稱",
  relatedCase: "關聯案件",
  canvasDescription: "畫布描述",
  caseName: "案件名稱",
  caseType: "案件類型",
  caseTypeName: "案件類型名稱",
  caseDescription: "案件說明",

  // 占位符
  pleaseEnterCanvasName: "請輸入畫布名稱(必填)",
  selectOrSearchCase: "請選擇或搜索案件",
  pleaseEnterCanvasDescription: "請輸入畫布描述（200字以內）",
  pleaseEnterCaseName: "請輸入案件名稱(必填)",
  pleaseSelectCaseType: "請選擇案件類型(必填)",
  pleaseSelectCaseTypeName: "請選擇案件類型名稱",
  pleaseEnterCaseDescription: "請輸入案件說明",

  // 按鈕
  cancel: "取消",
  confirm: "確認",
  saveCaseAndCanvas: "保存案件&畫布",
  addNewCase: "添加新案件",

  // 區域標題
  canvasInfo: "畫布信息",
  addNewCaseTitle: "添加新案件",

  // 驗證消息
  canvasNameRequired: "畫布名稱為必填項",
  caseRequired: "案件為必選項",
  caseNameRequired: "案件名稱為必填項",
  caseNameLength: "長度在 1 到 20個字符",
  pleaseSelectCaseTypeValidation: "請選擇案件類型",
  caseDescriptionLength: "長度在 1 到 200個字符",

  // 成功消息
  saveSuccess: "保存成功",

  // 畫布類型
  singleCurrencyCanvas: "單幣種畫布",
  multiCurrencyCanvas: "多幣種畫布",
};
